import { ICampaign } from "../Campaign/Campaign";

export interface IThirdPartyTracker {
    id?: string;
    tag?: string;
    type?: string;
    campaignId?: number;
}

export class ThirdPartyTracker implements IThirdPartyTracker {
    id?: string;
    tag?: string;
    type?: string;
    campaignId?: number;

    constructor()
    constructor(obj: IThirdPartyTracker)
    constructor(obj?: IThirdPartyTracker) {
        this.id = obj?.id || undefined;
        this.tag = obj?.tag || undefined;
        this.type = obj?.type || undefined;
        this.campaignId = obj?.campaignId || undefined;
    }
}